<div class="meetings" [class.mobile]="deviceService.isMobile()">
  <router-outlet></router-outlet>
</div>
